<template>
  <div>
    <button v-b-modal.modal-1 class="btn-primary btn-qustion btn-q1 dblock">
      {{ $t('date_input') }}
    </button>
    <b-modal
      id="modal-1"
      size="lg"
      :title="$t(shouldPickDateRange ? 'choose_two_dates' : 'date_input')"
      scrollable
      content-class="datepicker_dialog bd-example-modal-lg"
    >
      <b-container>
        <b-row>
          <b-col>
            <VueCtkDateTimePicker
              v-model="pickerDate"
              :locale="$store.state.language"
              format="YYYY-MM-DD HH:mm:ss"
              :min-date="getMinDate().toString()"
              :max-date="
                shouldPickDateRange && endTime
                  ? endTime.toString()
                  : getMaxDate().toString()
              "
              :inline="true"
              :overlay="true"
              color="#01509f"
              :no-button-now="true"
              minute-interval="15"
              :disabled-dates="disabledDates"
              :disabled-hours="disabledHours"
              :disabled-minutes="disabledMinutes"
            >
            </VueCtkDateTimePicker>
            <VueCtkDateTimePicker
              v-if="shouldPickDateRange"
              v-model="endTime"
              :locale="$store.state.language"
              format="YYYY-MM-DD HH:mm:ss"
              :min-date="pickerDate.toString()"
              :max-date="getMaxDate().toString()"
              :inline="true"
              :overlay="true"
              color="#01509f"
              :no-button-now="true"
              minute-interval="15"
              :disabled-dates="disabledDates"
              :disabled-hours="disabledHours"
              :disabled-minutes="disabledMinutes"
              class="datepicker_endTime"
            >
            </VueCtkDateTimePicker>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="datepicker_actions">
          <div class="flex-grow-1 datepicker_timerange">
            {{
              shouldPickDateRange
                ? `${dayjs(pickerDate).format('LL HH:mm')} - ${dayjs(
                    endTime
                  ).format('LL HH:mm')}`
                : undefined
            }}
          </div>
          <button class="btn dblock btn-link" @click="$bvModal.hide('modal-1')">
            {{ $t('button_cancel') }}
          </button>
          <button
            class="btn-qustion btn-q1 dblock btn-submit"
            @click="submitDate"
          >
            {{ $t('select_date') }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)
const VueCtkDateTimePicker = () => import('vue-ctk-date-time-picker')
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'DatePicker',
  components: {
    VueCtkDateTimePicker
  },
  props: {
    quickReply: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pickerDate: null,
      endTime: null,
      shouldPickDateRange: false,
      occupiedDates: this.$store.state.socket.lastMessageOccupiedDates || null,
      disabledHours: [], //["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
      disabledMinutes: [],
      disabledDates: [],
      hoursToDisable: []
    }
  },
  watch: {
    pickerDate(newVal, oldVal) {
      this.update_disabled_hours(newVal)
      this.update_disabled_minutes(newVal)
    }
  },
  created() {
    //this.pickerDate.setDate(this.pickerDate.getDate() + 1);
    //this.pickerDate.setHours(12);
    let current_date = new Date()
    let { disabledDays = [0, 6] } = this.quickReply.config || {}
    let {
      disabledHours = new Set([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        18,
        19,
        20,
        21,
        22,
        23
      ])
    } = this.quickReply.config || {}
    let all_hours = new Set([
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23
    ])
    this.hoursToDisable = disabledHours
    let { dateRange = false } = this.quickReply.config
    this.shouldPickDateRange = dateRange

    //let disabled_dates = [moment(current_date).format('YYYY-MM-DD')]
    let disabled_dates = []
    const listDate = []
    const startDate = this.getMinDate()
    const endDate = this.getMaxDate()
    const dateMove = new Date(startDate)
    let strDate = startDate
    while (strDate < endDate) {
      strDate = dateMove.toISOString().slice(0, 10)
      listDate.push(strDate)
      dateMove.setDate(dateMove.getDate() + 1)
    }
    let found_start_date = false
    const today = new Date().setHours(0)
    listDate.sort(
      (a, b) =>
        Math.abs(new Date(a).setHours(0) - today) -
        Math.abs(new Date(b).setHours(0) - today)
    )
    listDate.forEach(date => {
      let converted_date = new Date(Date.parse(date))
      if (disabledDays.includes(converted_date.getDay())) {
        disabled_dates.push(dayjs(date).format('YYYY-MM-DD'))
      } else {
        //let start_date = new Date(Date.parse(item["start_date"]));
        let disabled_hours = this.check_date(date)
        if (
          all_hours.size === disabled_hours.size &&
          [...all_hours].every(value => disabled_hours.has(value))
        ) {
          disabled_dates.push(dayjs(date).format('YYYY-MM-DD'))
        } else if (
          !found_start_date &&
          !disabled_dates.includes(dayjs(date).format('YYYY-MM-DD'))
        ) {
          this.pickerDate = date
          found_start_date = true
        }
      }
    })
    if (this.shouldPickDateRange) {
      const endDate = new Date(this.pickerDate)
      endDate.setHours(23)
      endDate.setMinutes(45)
      this.endTime = endDate
    }
    this.disabledDates = disabled_dates
  },
  methods: {
    dayjs,
    // getMaxDate() {
    //   let maxDate = new Date(Date.now())
    //   maxDate.setHours(23)
    //   maxDate.setMinutes(59)
    //   return dayjs(maxDate).format('YYYY-MM-DD HH:mm:ss')
    // },
    getMinDate() {
      let { minDateDayOffset = 1 } = this.quickReply.config || {}
      let minDate = new Date()
      minDate.setDate(minDate.getDate() + minDateDayOffset)
      return dayjs(minDate).format('YYYY-MM-DD')
    },
    getMaxDate() {
      let { maxDateDayOffset = 21 } = this.quickReply.config || {}
      let maxDate = new Date()
      maxDate.setDate(maxDate.getDate() + maxDateDayOffset)
      maxDate.setHours(23)
      maxDate.setMinutes(59)
      return dayjs(maxDate).format('YYYY-MM-DD HH:mm:ss')
    },
    submitDate() {
      let newTitle = ''
      let newQuickReply = {}
      if (this.shouldPickDateRange && this.endTime) {
        newTitle = `/${this.$i18n.t('date_range')}: ${this.$i18n.t(
          'from'
        )} ${this.$i18n.d(
          new Date(dayjs(this.pickerDate).format('YYYY-MM-DD HH:mm:ss')),
          'long'
        )} ${this.$i18n.t('to')} ${this.$i18n.d(
          new Date(dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss')),
          'long'
        )}/`
        newQuickReply = {
          title: newTitle,
          payload: `/inform{"time": {"from": "${dayjs(this.pickerDate).format(
            'YYYY-MM-DD HH:mm:ssZ'
          )}", "to": "${dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ssZ')}"}}`
        }
      } else {
        newTitle = `/${this.$i18n.t('date_input')}: ${this.$i18n.d(
          new Date(dayjs(this.pickerDate).format('YYYY-MM-DD HH:mm:ss')),
          'long'
        )}/`

        newQuickReply = {
          title: newTitle,
          payload: `/inform{"time":"${dayjs(this.pickerDate).format(
            'YYYY-MM-DD HH:mm:ssZ'
          )}"}`
        }
      }

      this.$emit('sendQuickReply', newQuickReply)
    },
    update_disabled_hours(date) {
      let disabled_hours = []
      let hours_to_disable = this.check_date(date)
      for (let item of hours_to_disable) {
        if (item < 10) disabled_hours.push('0' + item)
        else disabled_hours.push('' + item)
      }
      this.disabledHours = disabled_hours
      this.update_current_hour(hours_to_disable)
    },
    update_disabled_minutes(date) {
      let disabled_minutes = []
      let minutes_to_disable = this.check_date_minutes(date)
      for (let item of minutes_to_disable) {
        if (item < 10) disabled_minutes.push('0' + item)
        else disabled_minutes.push('' + item)
      }
      this.disabledMinutes = disabled_minutes
      this.update_current_minute(minutes_to_disable)
    },
    update_current_hour(disabled_hours) {
      let current_date = new Date(Date.parse(this.pickerDate))
      if (disabled_hours.has(current_date.getHours())) {
        let all_hours = new Set([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23
        ])
        for (let item of all_hours) {
          if (!disabled_hours.has(item)) {
            current_date.setHours(item)
            this.pickerDate = dayjs(current_date).format('YYYY-MM-DD HH:mm:ss')
            break
          }
        }
      }
    },
    update_current_minute(disabled_minutes) {
      let current_date = new Date(Date.parse(this.pickerDate))
      if (disabled_minutes.has(current_date.getMinutes())) {
        let all_minutes = new Set([0, 15, 30, 45])
        for (let item of all_minutes) {
          if (!disabled_minutes.has(item)) {
            current_date.setMinutes(item)
            this.pickerDate = dayjs(current_date).format('YYYY-MM-DD HH:mm:ss')
            break
          }
        }
      }
    },
    update_minute_interval(start_date, end_date) {
      this.minuteInterval = end_date.diff(start_date, 'minutes')
    },
    check_date(date) {
      let all_minutes = new Set([0, 15, 30, 45])
      let all_hours = new Set([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
      ])
      let hours_to_disable = new Set(this.hoursToDisable)
      let choosen_date = new Date(Date.parse(date))

      let hours_to_check = new Set()
      all_hours.forEach(elem => hours_to_check.add(elem))
      hours_to_disable.forEach(elem => hours_to_check.delete(elem))
      let hours_to_check_list = Array.from(hours_to_check)

      hours_to_check_list.forEach(item => {
        choosen_date.setHours(item, 0, 0)
        let minutes_to_disable = this.check_date_minutes(choosen_date)
        if (this.eqSet(minutes_to_disable, all_minutes)) {
          hours_to_disable.add(item)
        }
      })
      return hours_to_disable
    },

    check_date_minutes(date) {
      let choosen_date = new Date(Date.parse(date))
      let choosen_date_check = new Date(Date.parse(date))
      let all_minutes = new Set([0, 15, 30, 45])
      let minutes_to_disable = new Set([])
      if (this.getOccupiedDates) {
        this.getOccupiedDates.forEach(function(item, index) {
          let start_date = new Date(Date.parse(item['start_date']))
          let end_date = new Date(Date.parse(item['end_date']))

          if (choosen_date.toDateString() === start_date.toDateString()) {
            for (let item of all_minutes) {
              choosen_date_check.setMinutes(item)
              if (
                choosen_date_check >= start_date &&
                choosen_date_check <= end_date
              ) {
                minutes_to_disable.add(item)
              }
            }
          }
        })
      }

      return minutes_to_disable
    },

    eqSet(as, bs) {
      if (as.size !== bs.size) return false
      for (var a of as) if (!bs.has(a)) return false
      return true
    }
  }
}
</script>

<style lang="scss">
.modal-body {
  padding-bottom: 0;
  overflow: hidden;

  .col {
    padding-bottom: 1rem;
  }
}

.datepicker_dialog {
  background-color: #f3f4f6;
  overflow: hidden;

  .date-time-picker {
    max-width: 450px;
    overflow: hidden;
    border-radius: 9px;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .header-picker {
    background-color: #fff !important;
    padding: 16px 16px 10px 16px !important;
    border-bottom: 2px solid #f3f4f6;

    &-year {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.5);
    }

    &-date,
    &-time {
      font-size: 24px;
      margin-top: 4px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      flex: 1 1 50%;
    }

    &-time {
      padding-left: 0 !important;
      width: unset !important;
      max-width: unset !important;
      min-width: unset !important;
      flex: 1 1 30% !important;

      .time-number {
        font-size: 24px;
        font-weight: 500;
      }
    }
  }

  .time-picker {
    border-left: 2px solid #f3f4f6;
  }

  .datepicker-buttons-container {
    padding: 0;
  }

  footer {
    background-color: #fff;
    box-shadow: 0px -5px 15px -3px rgba(0, 0, 0, 0.1);
    border-top: none;
    padding: 0.75rem;
    display: block;

    .datepicker_actions {
      z-index: 9;
      display: flex;
      align-items: center;
      margin: 0;

      .btn-q1 {
        margin-bottom: 0;
        font-size: 14px;

        &.btn-submit {
          white-space: nowrap;
          padding: 8px 12px;
          margin: 0 0 0 8px;
        }
      }

      .btn-link {
        margin-bottom: 0;
        color: #01509f;
        font-size: 14px;
        padding: 0;
      }
    }
  }

  .datepicker-container .datepicker-controls .date-buttons {
    font-weight: 500;
  }

  .datepicker_endTime {
    margin-top: 12px;
  }

  .datepicker_timerange {
    display: flex;
    font-weight: bold;
    font-size: 14px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--buttonBackgroundColor);
    border-radius: var(--userInputBorderRadius);
  }

  &::-webkit-scrollbar-track {
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
</style>
